import type { Theme } from '../../types/theme';

export const minimaxTheme: Theme = {
  id: 'minimax',
  name: 'Minimax',
  description: 'Bold dark interface with neon cyan accents for AI model provider',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/minimax/DESIGN.md',
  visualKeywords: ['dark', 'neon cyan', 'AI model', 'bold', 'futuristic'],
  colors: {
    background: '#0a0a0a',
    surface: '#151515',
    surfaceElevated: '#1f1f1f',
    textPrimary: '#ffffff',
    textSecondary: '#808080',
    textMuted: '#808080',
    border: '#2a2a2a',
    borderSubtle: '#343434',
    primary: '#00d4ff',
    primaryHover: '#0fe3ff',
    primaryActive: '#00b6e1',
    accent: '#00d4ff',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'futuristic',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
